<template>
  <div
    :class="getCss('wrap')"
    :style="[styles.base, styles.fontStyle, { textAlign: configurationData.textAlign || 'center' }]"
  >
    <span
      v-if="configurationData.prependText"
      v-html="configurationData.prependText"
    ></span>

    <span :class="getCss('wrap-target')" :style="styles.targetFontStyle">{{
      targetData
    }}</span>
    <span
      v-if="configurationData.appendText"
      v-html="configurationData.appendText"
    ></span>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CTextDynamic',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'text-dynamic-',
      defaultText: ' ',
      dynamicData: {},
      targetData: '',
    };
  },
  computed: {
    textStyle() {
      return '';
    },
    targetTextStyle() {
      return '';
    },
    defaultValueText() {
      return this.configurationData.defaultValueText || '?';
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    eventListen() {
      const eventStr = this.configurationData?.targetText.replace(/{/g, '').replace(/}/g, '');
      const emitStr = this.configurationData?.emitStr || '';
      this.$eventBus.$on(`ceiba:common:events:textDynamic:${emitStr}`, ({ data }) => {
        if (data) {
          const eventStrArr = eventStr.split('|');
          if (eventStrArr.length > 1) {
            this.targetData = data[eventStrArr[0]][eventStrArr[1]];
          } else {
            this.targetData = data[eventStrArr[0]];
          }
        }
      });
    },
    async refreshFromAPI() {
      try {
        if (!this.configurationData.flowID) return;
        const options = {
          carryRoleFlag: true,
        };
        const params = {
          role: this.roleInfo,
        };
        const { forbiddenRequireRole = false } = this.configurationData;
        // 禁止强制传角色
        if  (forbiddenRequireRole === true) {
          params.role = {};
          options.carryRoleFlag = false;
        }
        // console.log('getDynamicText request=', this.configurationData.flowID);
        const time = Math.floor(Math.random() * 1000) + 400;
        await this.doSleep(time);
        // console.log('getDynamicText request timeout sleep ', time);
        const response = await this.flowRequest({
          flowId: this.configurationData.flowID,
          params,
          options,
        });
        console.log('getDynamicText response=', response);
        if (response.ret === 0) {
          this.dynamicData = response.data;
          this.targetData = this.getTargetData();
          if (this.configurationData?.showPagEvent && response?.data?.ret === 0) {
            this.$eventBus.$emit('ceiba:common:events:commercial:money:box:anime', { varying: this.configurationData?.showPagEvent });
          }
          console.log('this.this.targetData=', this.targetData);
        }
      } catch (e) {
        console.error('getDynamicText fail, err=', e);
      }
    },
    // 获取链接上的参数
    getInviteCodeFromUrl(arr) {
      const objVal = {};
      arr.forEach((v, i) => {
        objVal[v] = common.tool.getQueryparams(arr[i]) || '';
      });
      return objVal;
    },
    async initialize() {
      console.log('CTextDynamic version 1.3.11 configurationData sleep version', this.configurationData);
      this.targetData = this.getTargetData();
      const self = this;
      if (this.configurationData?.emitStr) {
        this.eventListen();
        return;
      }
      // 如果查询需要游戏角色
      if (this.configurationData.forceRole) {
        this.$onRoleReady(() => {
          if (self.configurationData.refreshOnQua) {
            self.refreshFromQua();
          } else {
            self.refreshFromAPI();
          }
        });
        this.$onQuaRefreshed(() => {
          if (!self.configurationData.refreshOnQua && this.isRoleReady) {
            self.refreshFromAPI();
          }
        });
      } else {
        this.$onQuaRefreshed(() => {
          if (self.configurationData.refreshOnQua) {
            self.refreshFromQua();
          } else {
            self.refreshFromAPI();
          }
        });
      }
    },
    getTargetData() {
      if (typeof this.configurationData.targetText === 'undefined') {
        return this.defaultText;
      }
      console.log('this.configurationData.targetText=', this.configurationData.targetText);
      // 匹配模式 支持多层传值匹配 比如 xxxx.xxxx.xxx
      const text = this.configurationData.targetText.replaceAll(/{{\s?([A-Za-z0-9_\\.\u4e00-\u9fa5]+)\s?}}/g, (_r, match) => this.getFields(this.dynamicData, match.split('.')));
      console.log('template text=', text);
      const result = this.configurationData.targetText.match(new RegExp('{{', 'g'));
      console.log('template text match  {{', result, this.configurationData.targetText);
      if (result.length > 1) {
        console.log('template text with ', text);
        // eslint-disable-next-line no-eval
        return text.indexOf('?') > -1 ? this.defaultValueText : eval(text);
      }
      return text.indexOf('?') > -1 ? this.defaultValueText : text;
    },
    getFields(object, querys) {
      console.log('getFields=', object, querys, this.$store.state, this.roleInfo);
      if (querys.length === 1 && querys[0] === '本人昵称') {
        return this.userInfo ? this.userInfo.nickName : '';
      }
      if (querys.length === 1 && querys[0] === '邀请人昵称') {
        return this.inviteUserInfo ? this.inviteUserInfo.nickName : '';
      }
      if (querys.length === 1 && querys[0] === '角色区服') {
        return common.tool.Base64.decode(this.roleInfo?.partition_name || '') || '';
      }
      if (querys.length === 1 && querys[0] === '角色昵称') {
        return common.tool.Base64.decode(this.roleInfo?.role_name || '') || '';
      }
      if (querys.length > 1) {
        const key = querys.shift();
        return this.getFields(object[key], querys);
      }
      let field = '?';
      if (querys[0] in object) {
        field = object[querys[0]];
        if (this.configurationData.targetEval) {
          // 存在eval表达式
          const evalStr = this.configurationData.targetEval.replaceAll(
            '结果',
            field === '?' ? '0' : field,
          );
          console.log('eval ', evalStr);
          // 受avenhuang强烈要求,暂时保留此安全隐患
          // http://tapd.oa.com/UP_DEV1/bugtrace/bugs/view?bug_id=1020373452095750445
          // eslint-disable-next-line no-eval
          field = eval(evalStr);
        }
      }
      return field;
    },
    refreshFromQua() {
      const packageStatus = this.quaInfo[this.configurationData.quaFlowID];
      // if (!packageStatus) return;
      if (packageStatus) {
        this.dynamicData = packageStatus;
      }
      this.targetData = this.getTargetData();
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
